import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router'
import { ConnectRestService } from '../services/connect-rest.service';
import { EnglishTranslation, MalayTranslation } from '../app.constants';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  Error: string;
  product: string;
  ReferenceNumber: any;
  IslamicNotEligible: any;
  textContent: any;

  constructor(
    private router: Router,
    private connect: ConnectRestService
  ) { }

  ngOnInit() {   
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.ThankYouScreen : MalayTranslation.ThankYouScreen;
    this.Error = localStorage.getItem("ErrorCode");
    this.IslamicNotEligible = sessionStorage.getItem('IslamicNotEligible');
    // added new condition for EDRP1 and EDRP2 Handling -- Kate 01/03/2022
    if(this.Error == "EDRP2"){
      var data = JSON.parse(sessionStorage.FinalResponse);
      this.ReferenceNumber = data.ReferenceNumber;
    }
  
    var locStorage=JSON.parse(localStorage.getItem("URLParam"));
    this.product=locStorage.ProductDescription;
    this.connect.clearSessionStorage();
  //  this.URLLink =  sessionStorage.Link
  
  }

  getQueryParams() {
    var params = { ...JSON.parse(localStorage.SavedQueryParams), productDescription: JSON.parse(localStorage.URLParam).ProductDescription };
    return params;
  }
}
